import React, { Component } from 'react';
import axios from 'axios';
import { fetchAPIData } from '../../../service/service';
import LoadingPage from '../../modals/LoadingPage/LoadingPage';
import './CustomerDetails.scss';
import InfoCard from './InfoCard/InfoCard';
import PaymentDetails from './PaymentDetails/PaymentDetails';
import ProfileCard from "./ProfileCard/ProfileCard";
import { getSecureItem, setSecureItem } from '../../../utilsFunctions';
import { BaseUrl } from '../../../Environment';




class CustomerDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loanDetails: {},
            collaterals:[],
            customerInfo: {},
            companyProfile:{},
            isLoading: false,
            fromOverDue: false,
            notPaidCollection: null,
            showChoiceModal: false,
            updatePreviousCollection: false,
            changePaymentProcessStatus: "",
        };

    }

    handleReceivePaymentClick = () => {
        if (this.state.notPaidCollection) {
            this.setState({ showChoiceModal: true });
        } else {
            this.handlePaymentProcessStatusChange("pay");
        }
    }

    handleCloseChoiceModal = () => {
        this.setState({ showChoiceModal: false });
    }

    handleNotPaidCollectionFound = (collection) => {
        this.setState({ notPaidCollection: collection });
    }

    handleUpdatePreviousCollection = (value) => {
        this.setState({ updatePreviousCollection: value });
    }

    handlePaymentDone = () => {
        this.setState({ updatePreviousCollection: false, notPaidCollection: null });
    }

    handlePaymentProcessStatusChange = (value) => {
    this.setState({ changePaymentProcessStatus: value }, () => {
        setTimeout(() => {
            this.setState({ changePaymentProcessStatus: "" });
        }, 100);
    });
}

    async componentWillMount() {
        const { location } = this.props.history
        const fromOverDue =
            this.props.history?.location?.state?.fromOverDue;
        this.setState({ fromOverDue: fromOverDue })
        let loanID, response
        if (location.state && location.state.loanID)
            loanID = location.state.loanID
        else
            loanID = getSecureItem('loanId')

        this.setState({ isLoading: true });
        response = await fetchAPIData("loanID", loanID)
        setSecureItem("loanTypeIdRePlan", response?.loanTypeId)
        setSecureItem("loanTypeRePlan", response?.loanType)
        setSecureItem("loanTenureTypeRePlan", response?.loanTenureType)
        
        this.setState({ loanDetails: response.loanDetails, collaterals: response.col , isLoading: response.isLoading });
        this.getCompanyProfile()
    }

    getCompanyProfile = async () => {
        try {
            const loggedinUser = getSecureItem("loggedinUserCompany");
            const token = getSecureItem("token");

            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            };

            const resp = await axios.get(
                `${BaseUrl}/company/getCompanyProfile?companyId=${loggedinUser}`,
                { headers }
            );

            if (resp.status === 200 && resp.data) {
                this.setState({ companyProfile: resp.data });
            }
        } catch (error) {
            console.error("Error fetching company profile:", error);
        }
    };

    getCustomerDetailsById = async (loanID) => {
        let response
        this.setState({ isLoading: true });
        response = await fetchAPIData("loanID", loanID)
        setSecureItem("loanTypeIdRePlan", response?.loanTypeId)
        setSecureItem("loanTypeRePlan", response?.loanType)
        setSecureItem("loanTenureTypeRePlan", response?.loanTenureType)

        this.setState({ loanDetails: response.loanDetails, collaterals: response.col, isLoading: response.isLoading });
    }


    notDone = () => {
        alert("Oops! sorry, this features is under construction")
    }

    render() {

        const { personalCardDetail, infoCard, loanHistoryDetailList,
            tentureType, isLoanActive, cancellationReason, method } = this.state.loanDetails
        const { customerInfo,companyProfile, isLoading, collaterals, fromOverDue, notPaidCollection, updatePreviousCollection } = this.state


        return (
            <div className="customerdetailsinfo">
                <LoadingPage isLoading={isLoading} />
                <div className="MainDiv">
                    <div className="firstcomponent">
                        <ProfileCard
                            action={this.getCustomerDetailsById}
                            customerInfo={customerInfo}
                            personalCardDetail={personalCardDetail}
                            isLoanActive={isLoanActive}
                            cancellationReason={cancellationReason}
                            method={method}
                            fromOverDue={fromOverDue}
                            onPaymentDone={this.handlePaymentDone}
                            notPaidCollection={notPaidCollection}
                            updatePreviousCollection={updatePreviousCollection}
                            onReceivePaymentClick={this.handleReceivePaymentClick}
                            onUpdatePreviousCollection={this.handleUpdatePreviousCollection}
                            onChangePaymentProcessStatus={this.handlePaymentProcessStatusChange}
                            changePaymentProcessStatus={this.state.changePaymentProcessStatus}
                        />
                    </div>

                    <div className="secondComponent">
                        <div className="infoLayout Fonts" >
                            <InfoCard customerInfo={personalCardDetail} infoCard={infoCard} isLoanActive={isLoanActive}
                                getCustomerDetailsById={this.getCustomerDetailsById}
                            />
                            <PaymentDetails
                                tentureType={tentureType}
                                loanHistoryDetailList={loanHistoryDetailList}
                                companyProfile={companyProfile}
                                collaterals={collaterals}
                                personalCardDetail={personalCardDetail}
                                isLoanActive={isLoanActive}
                                method={method}
                                action={this.getCustomerDetailsById}
                                history={this.props.history}
                                fromOverDue={fromOverDue}
                                notPaidCollection={notPaidCollection}
                                updatePreviousCollection={updatePreviousCollection}
                                choiceModalOpen={this.state.showChoiceModal}
                                onCloseChoiceModal={this.handleCloseChoiceModal}
                                onPaymentDone={this.handlePaymentDone}
                                onNotPaidCollectionFound={this.handleNotPaidCollectionFound}
                                onUpdatePreviousCollection={this.handleUpdatePreviousCollection}
                                onChangePaymentProcessStatus={this.handlePaymentProcessStatusChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default CustomerDetails;